export default __webpack_public_path__ + "static/badge_heron-f5d43ae77ac55815957629797bd2e07f.png";